module.exports = __webpack_public_path__ + "img/Edelstahlgelaender.dba2c3b1.webp";